import {
  Flex,
  Stack,
  Checkbox,
  Text,
  RadioGroup,
  Radio,
  Box,
  Button,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
 } from '@chakra-ui/react';
 import ButtonOnlyIcon from '../Button/Only-icon';
 import { QuestionHelper } from '../Data';
 import { InputText } from '../Input';
 import React from 'react';
 import { upload } from '../../assets/new-images/icons';
 import { NumericFormat } from 'react-number-format';
 import RotuloClassificacao from '../Catalog/RotuloClassificacao';
import RotuloGri from '../Catalog/RotuloGri';
import MedidasGriComoFormulario from '../Catalog/MedidasGriComoFormulario';
 
 const QuestionCardCertification = React.memo(({ editable, question, remove, children }) => {
  const { code, type, helper, isRequired, is_required } = question;
 
  const description =
   question?.description || question?.questionTitleTemplate?.[0]?.description || '';
 
  const questionOptions = question?.options || question?.question_option_template || [];
 
  const isQuestionRequired = isRequired === 'Sim' || is_required === true;
 
  const shouldShowEvidenceButton =
   question?.request_files === true ||
   question?.request_images === true ||
   question?.requestFiles === 'Sim' ||
   question?.requestImages === 'Sim';
 
  return (
   <Stack
    spacing={['16px', '24px']}
    {...(!editable && {
      p: '6',
      pb: '26px',
      bg: 'white',
      borderRadius: '12px',
      border: '2px solid #EAEEF0',
    })}
    pos='relative'
    width={'full'}
   >
    <Box maxW='86%'>
     {isQuestionRequired && (
      <Text
       as='span'
       color='orange.100'
       fontSize='12px'
       lineHeight='24px'
       fontWeight={500}
      >
       Pergunta obrigatória*
      </Text>
     )}
 
     <Text lineHeight='32px' mt='4px'>
      <b>{code}</b> -{' '}
      <Text as='span' fontWeight={500} dangerouslySetInnerHTML={{ __html: description }} />
     </Text>

     {/* EG-41 — CA05: a classificação vem logo abaixo do título. Fica FORA do
         <Text> acima de propósito: aquele nó usa dangerouslySetInnerHTML e
         não aceita filhos. */}
     <RotuloClassificacao
      idPillar={question?.id_pillar}
      idTheme={question?.id_theme}
     />

     {/* GRI-02 — CA02: os indicadores como tags. Linha própria porque são
         vários e quebram; o rótulo acima é sempre um só. */}
     {/* Na tela de templates o card vem do formulário, que guarda os IDS —
         daí `griIds`. `comRotulo` porque é aqui que a classificação é feita, e
         é onde mais importa enxergar de relance quais perguntas já viraram
         indicador e quais não. */}
     <RotuloGri gri={question?.gri} griIds={question?.gri_ids} comRotulo />

     {/* GRI-08: a previsão da caixa de medidas, igual à do respondente.
         Quem monta o questionário precisa ver o que está criando — nome,
         descrição e unidade do indicador, não só a tag do código. Na tela de
         template o card vem do formulário, que guarda os IDS: passa `griIds`
         pra prévia resolver contra o catálogo (antes ela ficava invisível ali). */}
     <MedidasGriComoFormulario gri={question?.gri} griIds={question?.gri_ids} />

     {/* GRI-07: indicador deixou de ser só etiqueta — cada um vira um campo de
         medida na tela do respondente (components/Survey/CamposIndicadorGri.tsx).
         Quem classifica aqui precisa saber que vincular N indicadores é
         adicionar N campos ao formulário, não só marcar uma tag. */}
     {(question?.gri?.length || question?.gri_ids?.length) > 0 && (
      <Text fontSize='11px' color='#1B5E30' mt='4px'>
       {(() => {
        const qtd = question?.gri?.length || question?.gri_ids?.length || 0;
        return `Esta questão terá ${qtd} campo${qtd > 1 ? 's' : ''} de medida no formulário do respondente`;
       })()}
      </Text>
     )}
    </Box>
 
    <QuestionHelper description={helper?.description || ''} videoUrl={helper?.url_video} />
 
    <Box>
     {(type === 'text' || type === 'number') && (
      <InputText
       name={`${question?.id || question?.id_question_template}`}
       type={type}
       width='400px'
      />
     )}
 
     {type === 'money' && (
      <NumericFormat
       displayType='input'
       thousandSeparator=','
       decimalSeparator='.'
       prefix='R$ '
       decimalScale={3}
       className='money_input'
       placeholder='R$ '
      />
     )}
 
     {type === 'percentage' && (
      <NumericFormat
       suffix='%'
       displayType='input'
       maxLength={4}
       fixedDecimalScale
       className='percentage_input'
       placeholder='% '
      />
     )}
 
     {type === 'multi_choice' && (
      <RadioGroup>
       <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
        {questionOptions?.map(
         (option, i) =>
          option?.description && (
           <Radio key={i} value={option?.value} isReadOnly>
            {option.description}
           </Radio>
          )
        )}
       </Flex>
      </RadioGroup>
     )}
 
     {type === 'multiple_choice' && (
      <>
       {question?.isCertified === true ||
       question?.isCertified === 'Sim' ||
       question?.is_certified === true ? (
        <Flex gap='24px' flexWrap='wrap'>
         {questionOptions?.map(
          (option, i) =>
           option?.description && (
            <Checkbox
             key={i}
             value={option?.value}
             name={`${question?.id}_${i}`}
             className='regular-checkbox'
            >
             <Text fontSize='sm' color='#5C6066'>
              {option.description}
              {(option?.isPrerequisite === 'Sim' ||
               option?.isPrerequisite === true ||
               option?.is_prerequisite === true) && (
               <Text as='span' color='#EA582B'>
                {' (pré-requisito)'}
               </Text>
              )}
             </Text>
            </Checkbox>
           )
         )}
        </Flex>
       ) : (
        <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
         {questionOptions?.map(
          (option, i) =>
           option?.description && (
            <Checkbox
             key={i}
             value={option?.value}
             name={`${question?.id}_${i}`}
             className='questionary-checkbox'
            >
             {option.description}
            </Checkbox>
           )
         )}
        </Flex>
       )}
      </>
     )}

     {type === 'grid' && question.gridRows && (question.gridColumns || question.options) && (
      <Box overflowX='auto' border='1px solid' borderColor='gray.200' borderRadius='md'>
       <Table variant='simple' size='sm'>
        <Thead bg='gray.50'>
         <Tr>
          <Th w='200px'></Th>
          {(question.gridColumns || question.options).map((col, colIndex) => (
           <Th key={colIndex} textAlign='center' fontSize='xs'>
            {col.description}
           </Th>
          ))}
         </Tr>
        </Thead>
        <Tbody>
         {question.gridRows.map((row, rowIndex) => (
          <Tr key={rowIndex}>
           <Td fontWeight='500' fontSize='sm'>
            {row.description}
           </Td>
           {(question.gridColumns || question.options).map((col, colIndex) => (
            <Td key={colIndex} textAlign='center'>
             <Radio 
              isDisabled 
              value={`${rowIndex}-${colIndex}`}
             />
            </Td>
           ))}
          </Tr>
         ))}
        </Tbody>
       </Table>
      </Box>
     )}
    </Box>
 
    {shouldShowEvidenceButton && (
     <Button
      alignSelf='flex-start'
      color='blue.100'
      bg='white'
      h='32px'
      p={0}
      display='flex'
      alignItems='center'
      _hover={{
       bg: 'none',
      }}
      _active={{
       bg: 'none',
      }}
     >
      <Image src={upload} alt='Upload icon' mr='4px' />
      <Text as='span' fontSize='sm' textDecor='underline' fontWeight={600}>
       Anexar Evidências
      </Text>
     </Button>
    )}
    {!editable && remove && 
      <ButtonOnlyIcon
        name='trash'
        h='32px'
        pos='absolute'
        right='24px'
        top='24px'
        onClick={remove}
      />
    }
    {children}
   </Stack>
  );
 });
 
 export default QuestionCardCertification;